// import { getCurrencyOptions } from '@/utils/constants/forex/currencies';
import React, { useEffect, useRef, useState } from 'react';

import CurrencyIcon from './components/reusables/CurrencyIcon';

export type Currency = {
  currencyCode: string;
  buyRate: number;
  sellRate: number;
  outwardRemittanceRate: number;
  reloadCardRate: any;
  unloadCardRate: any;
  customerBuyRate: number;
  customerSellRate: number;
  customerOutwardRemittanceRate: number;
  customerReloadCardRate: any;
  customerUnloadCardRate: any;
  exchangeRateDateTime: string;
  exchangeRateType: string;
  isSupportedByOmFx: boolean;
};

type CurrencyDropdownProps = {
  currencyOptions: Currency[];
  value: string;
  onChange: (selectedValue: string) => void;
  onSelect: (selectCurrency: Currency) => void;
  errorMessage: string;
  placeholder: string;
};

const CurrencyDropdown = (props: CurrencyDropdownProps) => {
  const { currencyOptions, value, onChange, onSelect, errorMessage } = props;

  const [category, setCategory] = useState<boolean>(false);
  const [selectedOptionIndex, setSelectedOptionIndex] = useState<number>();
  const [options, setOptions] = useState<Currency[]>([]);

  useEffect(() => {
    // const popularCurrencies = currencyOptions.filter(
    //   (option) => option.isSupportedByOmFx === true
    // );
    // const otherCurrencies = currencyOptions.filter(
    //   (option) => option.isSupportedByOmFx === false
    // );
    // setOptions([...popularCurrencies, ...otherCurrencies]);
    setOptions(currencyOptions);
  }, [currencyOptions]);

  useEffect(() => {
    const valueIndex = options.findIndex(
      (option) => option.currencyCode === value
    );

    if (valueIndex !== -1) {
      setSelectedOptionIndex(valueIndex);
    }
  }, [options, value]);

  useEffect(() => {
    const selectedOption =
      typeof selectedOptionIndex === 'number'
        ? options[selectedOptionIndex] || null
        : null;

    if (selectedOption && value !== selectedOption.currencyCode) {
      onChange(selectedOption.currencyCode);
      onSelect(selectedOption);
    }
  }, [selectedOptionIndex]);

  const onSelectedsetCategory = () => {
    setCategory(!category);
  };

  const setSelectedThenCloseDropdown = (index: number) => {
    setSelectedOptionIndex(index);
    setCategory(false);
  };

  const handleKeyDown =
    (index: number) => (e: React.KeyboardEvent<HTMLElement>) => {
      switch (e.key) {
        case ' ':
        case 'SpaceBar':
        case 'Enter':
          e.preventDefault();
          setSelectedThenCloseDropdown(index);
          break;
        default:
          break;
      }
    };

  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const eventListner = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setCategory(false);
      }
    };

    document.addEventListener('mousedown', eventListner);

    return () => document.removeEventListener('mousedown', eventListner);
  }, []);

  const handleListKeyDown = (e: React.KeyboardEvent<HTMLElement>) => {
    switch (e.key) {
      case 'Escape':
        e.preventDefault();
        setCategory(false);
        break;
      case 'ArrowUp':
        e.preventDefault();
        setSelectedOptionIndex((index) => {
          if (typeof index !== 'number') {
            return 0;
          }

          return index - 1 >= 0 ? index - 1 : options.length - 1;
        });
        break;
      case 'ArrowDown':
        e.preventDefault();
        setSelectedOptionIndex((index) => {
          if (typeof index !== 'number') {
            return 0;
          }

          return index == options.length - 1 ? 0 : index + 1;
        });
        break;
      default:
        break;
    }
  };

  return (
    <div className="input-container">
      <label
        className="text--regular fx-black-color fx-lable-name"
        htmlFor="basic-dropdown"
      >
        Currency
      </label>
      <div
        className="mfone-dropdown-list-item"
        id="basic-dropdown"
        ref={dropdownRef}
      >
        <div
          className="Category-item input-form category-dropdown"
          aria-haspopup="listbox"
          onKeyDown={handleListKeyDown}
          onClick={onSelectedsetCategory}
        >
          {/* <input
            readOnly
            value={value}
            className="mfone-cursor-pointer"
            placeholder={placeholder}
          /> */}
          {value && (
            <CurrencyIcon
              currencyCode={value}
              isFullFormRequired={true}
              className="mfone-cursor-pointer 
              "
            />
          )}
          <div
            className={category ? 'dropdown-arrow-selected' : 'dropdown-arrow'}
          ></div>
        </div>
        <div
          // style={{ display: category ? 'block' : 'none' }}
          className={`${category ? 'd-block' : 'd-none'} dropdownList`}
        >
          <ul
            className="category-list-items"
            role="listbox"
            aria-activedescendant={
              typeof selectedOptionIndex === 'number'
                ? options[selectedOptionIndex].currencyCode || ''
                : ''
            }
            tabIndex={-1}
            onKeyDown={handleListKeyDown}
          >
            {/* <li className="disable-text">Popular currencies</li> */}
            {options.map((optionItem, index) => (
              <li
                key={index}
                id={optionItem.currencyCode}
                role="option"
                aria-selected={selectedOptionIndex == index}
                tabIndex={0}
                className={selectedOptionIndex == index ? 'selected-li' : ''}
                onKeyDown={handleKeyDown(index)}
                onClick={() => {
                  setSelectedThenCloseDropdown(index);
                }}
              >
                {/* <Image 
style={{ color: undefined }} src={getCurrencyOptions(optionItem)} alt={optionItem.currencyCode} /> */}
                <CurrencyIcon
                  currencyCode={optionItem.currencyCode}
                  isFullFormRequired={true}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      <p className="text--red text--regular errorMessageDisplay">
        {errorMessage}
      </p>
    </div>
  );
};

export default CurrencyDropdown;
